<template>
  <div class="product-card uk-card uk-card-default uk-card-body">
    <img :src="product.image" :alt="product.name" class="product-image" />
    <h4>{{ product.name }}</h4>
    <p class="uk-text-meta">{{ product.shortDescription }}</p>
    <button class="uk-button uk-button-primary" @click="goToQuote(product)">Teklif Al</button>
  </div>
</template>

<script>
export default {
  props: ["product"],
  methods: {
    goToQuote(product) {
      this.$router.push({
        name: "QuoteForm",
        query: { product: product.name }
      });
    }
  }
};
</script>
